module.exports = __webpack_public_path__ + "static/media/failure_3.4983f031.gif";